<template>
    <svg fill="none" viewBox="0 0 4 14" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="2" height="8" rx="1" fill="currentColor" />
        <circle cx="2" cy="12" r="1.25" fill="currentColor" />
    </svg>
</template>
